import { APICore } from '../../helpers/api/apiCore';

const api = new APICore();

function getInventoryReport(params = {}) {
    const { location = 'All', trader = 'All', tagStatus = 'All' } = params;
    const queryParams = new URLSearchParams({ location, trader, tagStatus }).toString();
    return api.get(`/reports/currentInventory?${queryParams}`);
}

export { getInventoryReport };
